module.exports = __webpack_public_path__ + "img/debate23.d55da4c6.jpg";